import Link from 'next/link';
import React from 'react';

import { Typography } from '@sravni/react-design-system';

import { SravniNewsSharedModelsMaterialsHighLight } from '../../__generated__/news/Api';
import { LIST_BY_TAGS } from '../../constants/routes';
import { TPartnerMaterial } from '../../interfaces/news';
import { createLinkProps } from '../../utils/routing';
import { IRightColumnProps } from '../RightColumn/index';

import { Card } from './Card';
import styles from './read-on-block.module.scss';

export interface IReadOnBlockProps extends Omit<IRightColumnProps, 'materialId' | 'banners' | 'showAds'> {
  readOnBlockMaterials?: (SravniNewsSharedModelsMaterialsHighLight & TPartnerMaterial)[];
}

export const ReadOnBlock: React.FC<IReadOnBlockProps> = ({
  readOnBlockMaterials: materials,
  readOnBlockTitle: title = 'Читайте по теме',
}) => {
  const { href, as } = createLinkProps('list', LIST_BY_TAGS, {
    tag: 'partnerskij-material',
  });

  return (
    <div>
      <Typography.Text size={14} strong className={'h-color-D30 h-mb-12'}>
        {title}
      </Typography.Text>
      {materials?.slice(0, 2).map((item) => (
        <Card item={item} key={item.alias} />
      ))}
      <Link href={href} as={as}>
        <Typography.Link className={styles.allMaterialsLink}>Все материалы</Typography.Link>
      </Link>
    </div>
  );
};
